import { Component } from '@angular/core';

/**
 * Component to encapsulate a page to get the default flex properties
 */
@Component({
  selector: 'app-page',
  imports: [],
  template: `
    <div class="page">
      <div class="content">
        <ng-content />
      </div>
    </div>
  `,
  styleUrls: ['./page.component.scss'],
})
export class PageComponent {}
